import loadable from '@loadable/component';

export const GradFairHomeContainerLoadable = loadable(
  () => import('./GradFairHomeContainer'),
  {
    resolveComponent: (module) => module.GradFairHomeContainer,
  },
);
